export const ROUTE = {
  MAIN: '/',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  EMBED: {
    GIVEAWAY: '/:uuid/embed',
    CHAOS_WIDGET: '/:uuid/chaos-widget'
  },
  ADMIN: {},
  AUTH: {
    TWITCH_CALLBACK: '/twitch/oauth',
    DESKTOP_OAUTH_AUTHORIZE: '/dashboard/oauth-authorize'
  },
  DASHBOARD: {
    MAIN: '/dashboard',
    RULES: '/dashboard/rules',
    COMMANDS: '/dashboard/commands',
    AUTOMODE: '/dashboard/automode',
    CHAOS: '/dashboard/chaos',
    CHAOS_WIDGET: '/dashboard/chaos-widget',
    GIVEAWAY: '/dashboard/giveaway',
    GIVEAWAY_EMBED: '/dashboard/giveaway-embed',
    VIEWERS: '/dashboard/viewers',
    PROFILE: '/dashboard/profile',
    USERS: '/dashboard/users'
  }
};
